import React from 'react';
import styled from 'styled-components';
import { IBase, BaseBox } from '@docon/docon-ui-library';

interface IProps extends IBase {
  name: string;
  onChange: (x: { name: string; value: any }) => void;
}

const Root = styled(BaseBox)`
  display: none;
`;

const FileInput = React.forwardRef(({
  name, onChange, ...props
}: IProps, ref) => {

  function handleChange(event: any) {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    event.target.value = '';
    onChange({ name, value: file });
  }

  return (
    <Root
      ref={ref}
      type='file'
      as={'input'}
      onChange={handleChange}
      {...props}
    />
  );
});

FileInput.displayName = 'FileInput';
export default FileInput;